export default "__VITE_ASSET__DtsOYrTV__"